// What a rejected /zones call actually hands you is not an Error. The services
// in systemIdentification.service.js re-throw `error?.response?.data`, so:
//
//   - the server answered and rejected  -> the response body, shape varies
//   - the request never got there       -> there is no response, so `undefined`
//
// The second case is the one that matters most, because it is also the case
// where reading `.message` off the thrown value would itself throw and leave
// the user with the optimistic success message still on screen.
export const describeZonesError = (error) => {
  if (!error) {
    return 'could not reach the server. the change was not saved.';
  }

  if (typeof error === 'string') {
    return error;
  }

  const detail = error.message ?? error.error ?? error.detail;

  if (typeof detail === 'string' && detail.trim()) {
    return detail;
  }

  // A blank or non-string field is worse than no field at all: it renders an
  // empty dialog that reads as a broken app rather than as a refused save.
  return 'the server rejected the change. the change was not saved.';
};

